import React, { useState, useEffect, useMemo } from "react";
import DataTable from "../components/DataTable.js";
import { fetchDataFromAPI, saveData, deleteData } from "../components/api.js";
import subscriptionStatus from "../components/SubscriptionStatus.js";
const getRangeInputProps = (col) => {
  if (col.type === "range") {
    return { min: 0, max: 5, step: 0.5 }; // Limit range inputs to 0-5 with step of 0.1
  }
  return {}; // Return empty object for non-range types
};
const ShippingCompany = () => {
  const [shippingCompany, setShippingCompany] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({});
  const [sortField, setSortField] = useState("created_at"); // Track the current sorted field
  const [sortOrder, setSortOrder] = useState("desc"); // Track the current sort order
  const [productsOptions, setProductsOptions] = useState([]);
  const [error, setError] = useState(null);
  const isSubscribed = subscriptionStatus();
  useEffect(() => {
    fetchData();
    console.log("referching data", currentPage, filters, sortField, sortOrder);
  }, [filters, sortField, sortOrder]);

  const fetchData = async (page = 1, itemsPerPage = 10, filters = {}) => {
    try {
      console.log("fetchData", filters, sortField, sortOrder);
      const token = localStorage.getItem("token");
      console.log("filters", filters);

      // Prepare query parameters

      // Dynamically construct query parameters, excluding empty sortField and sortOrder
      const filterParamsObj = {
        page,
        limit: 10,
        ...filters,
        includeDeleted: "false",
      };

      // Add sortField and sortOrder only if they are not empty
      if (sortField) {
        filterParamsObj.sortField = sortField;
      }
      if (sortOrder) {
        filterParamsObj.sortOrder = sortOrder;
      }
      Object.keys(filterParamsObj).forEach(
        (key) => filterParamsObj[key] === "" && delete filterParamsObj[key]
      );
      // Create the query string
      const filterParams = new URLSearchParams(filterParamsObj).toString();
      console.log("Filter Params:", filterParams);
      // Fetch suppliers and materials concurrently
      const { data: shippingCompany, pagination } = await fetchDataFromAPI(
        `/api/shipping-companies`,
        filterParams,
        token
      );

      //   const { data: products } = await fetchDataFromAPI(
      //     `/api/products`,
      //     {},
      //     token
      //   );

      // Update state
      setShippingCompany(shippingCompany || []);
      //   setProductsOptions(products || []);
      setTotalPages(pagination?.totalPages || 1);

      console.log("shippingCompany:", shippingCompany);
      //   console.log("Products:", products);
    } catch (err) {
      console.error("Error fetching data:", err.message);
      setError(err.message);
    }
  };

  const handleAddRow = async () => {
    try {
      const index = shippingCompany.length + 1;

      const newRow = {
        name: `Shipping Company ${index}`,
        status: "active",
      };

      await saveData("/api/shipping-companies", newRow, "POST");
      fetchData();
    } catch (err) {
      console.error("Error adding row:", err);
    }
  };

  const handleEdit = async (id, updatedData) => {
    try {
      await saveData(`/api/shipping-companies/${id}`, updatedData);
      fetchData();
    } catch (err) {
      console.error("Error editing order:", err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteData(`/api/shipping-companies/${id}`);
      fetchData();
    } catch (err) {
      console.error("Error deleting order:", err);
    }
  };
  const handlePageChange = (newPage) => {
    console.log("Parent - Page changed to:", newPage); // Log in parent
    setCurrentPage(newPage); // Update the current page
    fetchData(newPage, 10); // Fetch new data
  };
  const handleSort = (field, order) => {
    console.log("handleSort,field,order", field, order);
    setSortField(field); // Update the sorted field
    setSortOrder(order); // Update the sort order (asc/desc)
  };
  const handleFilterChange = (newFilters) => {
    console.log("handleFilterChange", newFilters);
    setFilters(newFilters); // Update filters in the parent state
    fetchData(currentPage, itemsPerPage, newFilters); // Refetch data with new filters
  };
  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Phone Number", accessor: "phone_number" },
    { header: "Email", accessor: "email" },
    { header: "Social Links", accessor: "social_links" },
    { header: "Location", accessor: "location" },
    { header: "Price Range", accessor: "price_range", type: "range" },
    { header: "Website URL", accessor: "website_url" },
    { header: "Service Type", accessor: "service_type" },
    {
      header: "Estimated Delivery Time",
      accessor: "estimated_delivery_time",
      type: "range",
    },
    { header: "Tracking URL", accessor: "tracking_url" },
    { header: "Shipping Methods", accessor: "shipping_methods" },
    { header: "Delivery Area", accessor: "delivery_area" },
    { header: "Insurance Options", accessor: "insurance_options" },
    { header: "Carrier Code", accessor: "carrier_code" },
    { header: "Contact Person", accessor: "contact_person" },
    { header: "Payment Terms", accessor: "payment_terms" },
    {
      header: "Reliability Rating",
      accessor: "reliability_rating",
      type: "range",
    },
  ];

  console.log("columns", columns);
  return (
    <DataTable
      title="Shipping Company"
      columns={columns}
      data={shippingCompany}
      currentPage={currentPage}
      setData={setShippingCompany}
      totalPages={totalPages}
      onSort={handleSort}
      sortOrder={sortOrder}
      sortField={sortField}
      onPageChange={handlePageChange}
      filters={filters}
      onFilterChange={handleFilterChange}
      onAddRow={handleAddRow}
      actions={[
        {
          label: "Edit",
          onClick: (row) => {
            const updatedData = { ...row, name: "Updated Name" };
            handleEdit(row.id, updatedData);
          },
        },
        {
          label: "Delete",
          onClick: (row) => handleDelete(row.id),
        },
      ]}
      apiEndpoint="/api/shipping-companies"
      itemsPerPage={10}
      fetchData={fetchData}
      getRangeInputProps={getRangeInputProps}
      selectedItems={shippingCompany}
    />
  );
};

export default ShippingCompany;
